export const _setEmployees = (state, action) => action.payload;
